import { render, staticRenderFns } from "./goodInfo.vue?vue&type=template&id=f0a67aa8&"
import script from "./goodInfo.vue?vue&type=script&lang=js&"
export * from "./goodInfo.vue?vue&type=script&lang=js&"
import style0 from "./goodInfo.vue?vue&type=style&index=0&id=f0a67aa8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports